/**
 * Crown & Paw — analytics event layer (04-tracking-plan.csv).
 *
 * Vendor-neutral: window.cpTrack pushes to window.dataLayer (GTM standard) AND dispatches a
 * `cp:<event>` DOM event, so either a GTM container or a Shopify custom pixel can consume it.
 * No-op until one is connected; needs no IDs. Never send PII (names / message text) — counts
 * and labels only. Consent is gated at the GTM / pixel layer (e.g. GTM Consent Mode).
 *
 * This file owns window.cpTrack and the pure click / viewport events that read straight from
 * the DOM: nav tile / promo / chip clicks and grid info-card view + click. The stateful events
 * (menu open, countdown view/click, collection filter/sort, gift-finder select) are fired from
 * their own section scripts, which call window.cpTrack directly.
 */
(function () {
  function track(name, params) {
    params = params || {};
    try {
      var o = { event: name };
      for (var k in params) { if (Object.prototype.hasOwnProperty.call(params, k)) o[k] = params[k]; }
      (window.dataLayer = window.dataLayer || []).push(o);
      document.dispatchEvent(new CustomEvent('cp:' + name, { detail: params }));
    } catch (e) {}
  }
  window.cpTrack = window.cpTrack || track;

  function txt(el) { return el ? (el.textContent || '').replace(/\s+/g, ' ').trim() : ''; }
  function posWithin(el, container, selector) {
    if (!container) return 1;
    var sibs = container.querySelectorAll(selector);
    for (var i = 0; i < sibs.length; i++) { if (sibs[i] === el) return i + 1; }
    return 1;
  }
  function collHandle() {
    var c = document.querySelector('[data-cp-collection]');
    return c ? (c.getAttribute('data-cp-collection-handle') || '') : '';
  }
  function cardType(gcard) {
    if (!gcard) return '';
    var t = gcard.getAttribute('data-cp-card-type');
    if (t) return t;
    var m = (gcard.className || '').match(/cp-col__gcard--([\w-]+)/);
    return m ? m[1] : '';
  }

  /* ---- delegated clicks ---- */
  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;

    // Mega-menu promo band CTA
    var promo = e.target.closest('a.cp-mega__promo-cta');
    if (promo) {
      var band = promo.closest('.cp-mega__promo');
      var pan = promo.closest('[data-cp-panel]');
      window.cpTrack('nav_promo_click', {
        menu_slot: pan ? pan.getAttribute('data-cp-panel') : '',
        promotion_id: band ? (band.getAttribute('data-cp-promo-id') || '') : '',
        headline: band ? txt(band.querySelector('.cp-mega__promo-head')) : ''
      });
      return;
    }

    // Mega-menu content links (tiles / thumbs / pills / see-all / feature)
    var panel = e.target.closest('[data-cp-panel]');
    if (panel) {
      var link = e.target.closest('a[href]');
      if (link && panel.contains(link) && !link.classList.contains('cp-mega__promo-cta')) {
        var grp = link.closest('.cp-mega__group, .cp-mega__feature');
        var label = txt(link.querySelector('.cp-mega__tile-label, .cp-mega__thumb-label, .cp-mega__feature-title')) || txt(link);
        var pos = 1;
        if (link.classList.contains('cp-mega__tile')) pos = posWithin(link, link.closest('.cp-mega__tiles'), '.cp-mega__tile');
        else if (link.classList.contains('cp-mega__thumb')) pos = posWithin(link, link.closest('.cp-mega__thumbs'), '.cp-mega__thumb');
        else if (link.classList.contains('cp-mega__pill')) pos = posWithin(link, link.closest('.cp-mega__pills'), '.cp-mega__pill');
        window.cpTrack('nav_tile_click', {
          menu_slot: panel.getAttribute('data-cp-panel'),
          block_heading: grp ? txt(grp.querySelector('.cp-mega__eyebrow')) : '',
          item_label: label,
          destination_url: link.getAttribute('href') || '',
          position: pos
        });
        return;
      }
    }

    // Mobile chip rail
    var chip = e.target.closest('a.cp-chip');
    if (chip) {
      window.cpTrack('nav_chip_click', {
        chip_label: txt(chip),
        destination_url: chip.getAttribute('href') || '',
        position: posWithin(chip, chip.closest('.cp-chips__inner'), '.cp-chip')
      });
      return;
    }

    // Collection grid info-card CTA (feature cards are the <a> themselves)
    var gc = e.target.closest('.cp-col__gc-cta, a.cp-col__gcard');
    if (gc) {
      var gcard = gc.closest('.cp-col__gcard') || gc;
      window.cpTrack('grid_card_click', {
        collection_handle: collHandle(),
        card_type: cardType(gcard),
        slot: gcard.getAttribute('data-cp-card-slot') || ''
      });
      return;
    }

    // Homepage gift finder — recipient tile / budget pill (links out to the gift guide)
    var gfFor = e.target.closest('[data-cp-gf-for]');
    if (gfFor) {
      window.cpTrack('gift_finder_select', { recipient: gfFor.getAttribute('data-cp-gf-for') || '', budget: '', source: 'homepage' });
      return;
    }
    var gfBudget = e.target.closest('[data-cp-gf-budget]');
    if (gfBudget) {
      window.cpTrack('gift_finder_select', { recipient: '', budget: gfBudget.getAttribute('data-cp-gf-budget') || '', source: 'homepage' });
      return;
    }
  });

  /* ---- viewport: grid info cards (once per page view) ---- */
  function slotPosition(g) {
    var grid = g.closest('.cp-col__grid');
    if (!grid) return 0;
    var kids = grid.children;
    for (var i = 0; i < kids.length; i++) { if (kids[i] === g) return i + 1; }
    return 0;
  }
  // Seen grid cards keyed by type+slot, kept OUTSIDE the grid DOM so AJAX swaps (which replace the card
  // nodes) can't reset the flag and re-fire grid_card_view — a once-per-page-view event.
  var seenCardKeys = {};
  function cardKey(g) {
    return (g.getAttribute('data-cp-card-type') || '') + '|' + (g.getAttribute('data-cp-card-slot') || '');
  }
  function observeCards() {
    if (!('IntersectionObserver' in window)) return;
    var cards = document.querySelectorAll('.cp-col__gcard[data-cp-card-slot]');
    if (!cards.length) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        var g = en.target;
        io.unobserve(g);
        var k = cardKey(g);
        if (seenCardKeys[k]) return;   // already counted this card this page view
        seenCardKeys[k] = true;
        window.cpTrack('grid_card_view', {
          collection_handle: collHandle(),
          card_type: cardType(g),
          slot: g.getAttribute('data-cp-card-slot') || '',
          position: slotPosition(g)
        });
      });
    }, { threshold: 0.5 });
    for (var i = 0; i < cards.length; i++) {
      if (seenCardKeys[cardKey(cards[i])]) continue;   // already viewed before an AJAX swap
      io.observe(cards[i]);
    }
  }
  // Re-run after collection AJAX swaps (collection.js calls this).
  window.cpObserveCards = observeCards;

  if (document.readyState !== 'loading') observeCards();
  else document.addEventListener('DOMContentLoaded', observeCards);
})();
